import React from 'react';
import { Gift } from 'lucide-react';
export function Bonuses() {
  const bonuses = [{
    num: '1',
    title: 'Guía de Planificación Anual',
    desc: 'Plantillas para clases de 45, 60 y 80 min. Secuencias completas por tomo.',
    value: 'USD 15'
  }, {
    num: '2',
    title: 'Banco de Ejercicios Anti-IA',
    desc: '80+ ejercicios que ChatGPT no puede resolver. Contexto real del alumno.',
    value: 'USD 12'
  }, {
    num: '3',
    title: 'Errores Comunes + Cómo Explicarlos',
    desc: '80+ errores con analogías pedagógicas y estrategias de corrección.',
    value: 'USD 10'
  }, {
    num: '4',
    title: 'Evaluaciones Listas con Rúbrica',
    desc: '8 evaluaciones completas con solución comentada y rúbrica objetiva.',
    value: 'USD 9'
  }];
  return <section className="py-3 md:py-4 px-3 bg-brand-dark border-b border-white/5" data-id="element-17">
      <div className="max-w-4xl mx-auto" data-id="element-18">
        <div className="text-center mb-2" data-id="element-19">
          <div className="inline-flex items-center justify-center bg-brand-gold/10 text-brand-gold font-semibold px-3 py-1 rounded-full mb-1 text-[10px] tracking-tight uppercase border border-brand-gold/20" data-id="element-20">
            <Gift className="w-3 h-3 mr-1" data-id="element-21" /> Incluidos sin costo extra
          </div>
          <h2 className="text-lg md:text-xl font-bold text-white uppercase tracking-tight" data-id="element-22">
            🎁 4 Bonos Estratégicos
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-2 mb-3" data-id="element-23">
          {bonuses.map((bonus, i) => <div key={i} className="bg-brand-card rounded-xl p-3 border border-white/10 hover:border-white/20 transition-colors flex items-start gap-3" data-id="element-24">
              <div className="bg-brand-gold/15 text-brand-gold font-semibold text-[9px] px-2 py-0.5 rounded-full shrink-0 mt-0.5 uppercase" data-id="element-25">
                {bonus.num}
              </div>
              <div className="flex-1 min-w-0" data-id="element-26">
                <h3 className="text-xs md:text-sm font-semibold text-white mb-0.5 leading-tight" data-id="element-27">
                  {bonus.title}
                </h3>
                <p className="text-[10px] text-gray-500 leading-relaxed font-normal" data-id="element-28">
                  {bonus.desc}
                </p>
                <div className="flex items-center gap-2 mt-1" data-id="element-29">
                  <span className="text-gray-600 line-through text-[9px] font-medium" data-id="element-30">
                    {bonus.value}
                  </span>
                  <span className="text-brand-gold font-semibold text-[10px]" data-id="element-31">
                    GRATIS
                  </span>
                </div>
              </div>
            </div>)}
        </div>

        <div className="bg-brand-card rounded-xl p-2 text-center border border-brand-gold/20 max-w-xs mx-auto" data-id="element-32">
          <p className="text-[10px] font-medium text-gray-300" data-id="element-33">
            Valor total:{' '}
            <span className="line-through text-gray-600" data-id="element-34">USD 46</span>
          </p>
          <p className="text-base font-bold text-brand-gold my-0.5" data-id="element-35">
            🎁 GRATIS
          </p>
          <p className="text-[9px] text-gray-500 font-normal" data-id="element-36">
            Solo en este lanzamiento.
          </p>
        </div>
      </div>
    </section>;
}